/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlTransformation
 */
export interface ControlTransformation {
    /**
     * 
     * @type {string}
     * @memberof ControlTransformation
     */
    originalControlId?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlTransformation
     */
    resolvedControlId?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlTransformation
     */
    transformationType?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlTransformation
     */
    sourceCatalog?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlTransformation
     */
    organizationalValuesApplied?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlTransformation
     */
    modificationsApplied?: Array<string>;
}

/**
 * Check if a given object implements the ControlTransformation interface.
 */
export function instanceOfControlTransformation(value: object): value is ControlTransformation {
    return true;
}

export function ControlTransformationFromJSON(json: any): ControlTransformation {
    return ControlTransformationFromJSONTyped(json, false);
}

export function ControlTransformationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlTransformation {
    if (json == null) {
        return json;
    }
    return {
        
        'originalControlId': json['originalControlId'] == null ? undefined : json['originalControlId'],
        'resolvedControlId': json['resolvedControlId'] == null ? undefined : json['resolvedControlId'],
        'transformationType': json['transformationType'] == null ? undefined : json['transformationType'],
        'sourceCatalog': json['sourceCatalog'] == null ? undefined : json['sourceCatalog'],
        'organizationalValuesApplied': json['organizationalValuesApplied'] == null ? undefined : json['organizationalValuesApplied'],
        'modificationsApplied': json['modificationsApplied'] == null ? undefined : json['modificationsApplied'],
    };
}

export function ControlTransformationToJSON(json: any): ControlTransformation {
    return ControlTransformationToJSONTyped(json, false);
}

export function ControlTransformationToJSONTyped(value?: ControlTransformation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'originalControlId': value['originalControlId'],
        'resolvedControlId': value['resolvedControlId'],
        'transformationType': value['transformationType'],
        'sourceCatalog': value['sourceCatalog'],
        'organizationalValuesApplied': value['organizationalValuesApplied'],
        'modificationsApplied': value['modificationsApplied'],
    };
}

